import React from "react";

export default function FrameworkList({ frameworks, onOpen }) {
  if (frameworks.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-8 text-center text-sm text-gray-500">
        No frameworks to show.
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
      {frameworks.map((fw) => (
        <button
          key={fw.id}
          type="button"
          onClick={() => onOpen(fw.id)}
          className="w-full text-left p-4 flex flex-col sm:flex-row sm:items-center gap-4 hover:bg-gray-50 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-300"
        >
          <div className="w-10 h-10 rounded-lg bg-indigo-50 text-indigo-700 font-semibold flex items-center justify-center flex-shrink-0 text-xs">
            {fw.shortName}
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="font-medium text-gray-900">{fw.name}</span>
              {!fw.enabled && (
                <span className="text-[10px] font-medium text-gray-500 bg-gray-100 rounded-full px-2 py-0.5">
                  Disabled
                </span>
              )}
            </div>
            <p className="text-xs text-gray-500 truncate">{fw.description}</p>

            <div className="mt-2 h-2 w-full max-w-sm rounded-full bg-slate-100 overflow-hidden flex">
              <div
                className="h-full bg-green-500"
                style={{ width: `${fw.totalControls ? (fw.implemented / fw.totalControls) * 100 : 0}%` }}
              />
              <div
                className="h-full bg-blue-500"
                style={{ width: `${fw.totalControls ? (fw.inProgress / fw.totalControls) * 100 : 0}%` }}
              />
            </div>
          </div>

          <div className="flex items-center gap-4 text-xs text-gray-600 flex-shrink-0">
            <span><span className="font-semibold text-gray-900">{fw.implemented}</span> Implemented</span>
            <span><span className="font-semibold text-gray-900">{fw.notStarted + fw.inProgress}</span> Pending</span>
            <span><span className="font-semibold text-gray-900">{fw.unassigned}</span> Unassigned</span>
            <span className="text-base font-bold text-gray-900">{fw.score}%</span>
          </div>
        </button>
      ))}
    </div>
  );
}
